import { useMemo } from "react";
import { useAuth } from "@clerk/clerk-react";
import { AnalyticsProvider, createGatewayCall } from "@flobi/asset-library/analytics";
import "@flobi/asset-library/share.css";
import "@flobi/asset-library/analytics.css";

/**
 * Suite analytics for Artwork (@flobi/asset-library/analytics): the first-visit card, then app opened,
 * active minutes and feature use (the signals Artwork already sends), through the gateway as the
 * signed-in Flobi user.
 */
export default function ArtworkAnalyticsHost() {
  const { isSignedIn, getToken } = useAuth();
  const call = useMemo(() => createGatewayCall({ baseUrl: import.meta.env.VITE_BACKEND_URL, getToken }), [getToken]);
  return <AnalyticsProvider call={call} app="artwork" theme="artwork" enabled={Boolean(isSignedIn)} appLabel="Artwork" />;
}
